import { useState } from "react";
import { Link } from "react-router-dom";
import trainers from "../../data/trainers";
import TrainerCard from "../common/TrainerCard";
import TrainerModal from "./TrainerModal";
import SectionHeading from "../common/SectionHeading";
import "./TrainersPreview.css";

export default function TrainersPreview() {
  const [selected, setSelected] = useState(null);

  return (
    <section className="trainers-preview section">
      <div className="container">
        <div className="trainers-preview__head">
          <SectionHeading eyebrow="Meet The Coaches" title="Trainers who" highlight="know your name" />
          <Link to="/trainers" className="btn btn-outline">All Trainers</Link>
        </div>
        <div className="trainers-preview__grid">
          {trainers.map((trainer) => (
            <TrainerCard trainer={trainer} onOpen={setSelected} key={trainer.id} />
          ))}
        </div>
      </div>
      {selected && <TrainerModal trainer={selected} onClose={() => setSelected(null)} />}
    </section>
  );
}
